import { hotTopics, metrics } from '@/mocks/heiliao';
import type { HotTopic } from '@/pages/home/types';

const topFive = hotTopics.slice(0, 5);

export default function HeroSection() {
  return (
    <section id="home" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20background%20with%20deep%20crimson%20red%20and%20warm%20gold%20ink%20textures%2C%20dark%20moody%20atmosphere%2C%20soft%20light%20beams%2C%20dramatic%20shadow%2C%20artistic%20magazine%20cover%20aesthetic%2C%20high%20contrast%2C%20textured%20paper%20grain&width=1600&height=900&seq=gossip-hero-01&orientation=landscape"
          alt="44黑料区娱乐舆论话题目录站的编辑风格背景画面"
          className="h-full w-full object-top object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/80 to-foreground-950/45"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-transparent to-foreground-950/40"></div>
      </div>

      <div className="relative mx-auto grid w-full max-w-[1400px] grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-[1.35fr_0.85fr] lg:items-center lg:py-24">
        <div className="w-full">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-500/60 bg-accent-500/10 px-3.5 py-1.5 text-xs tracking-wider text-accent-300">
            <i className="ri-folder-open-line"></i>
            分类目录 · 标签导航 · 热度索引
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-[1.25] text-background-50 sm:text-4xl md:text-5xl lg:text-[56px]">
            44黑料区
            <span className="mt-2 block text-xl font-bold text-background-200 sm:text-2xl md:text-3xl">
              娱乐舆论话题的结构化分类目录
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-300 md:text-base">
            按明星、网红、政商、社会等标签分区整理公开话题，提供清晰的黑料目录与导航索引。
            不用在信息流里反复翻找，从分区或标签直接进入，快速定位你感兴趣的专属领域。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#categories"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-layout-grid-line"></i>
              浏览分类目录
            </a>
            <a
              href="#ranking"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-400/60 px-6 py-3 text-sm font-medium text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              <i className="ri-fire-line"></i>
              查看热度排行
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-600/50 pt-7 sm:grid-cols-4">
            {metrics.map((item) => (
              <div key={item.label}>
                <dt className="font-heading text-2xl font-black text-accent-400 md:text-3xl">{item.value}</dt>
                <dd className="mt-1 text-xs text-background-400">{item.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <aside className="w-full rounded-lg border border-background-700/60 bg-background-950/70 p-5 backdrop-blur md:p-6">
          <div className="flex items-center justify-between border-b border-background-700/60 pb-4">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-background-50">
              <i className="ri-fire-fill text-primary-500"></i>
              今日热度 TOP 5
            </h2>
            <a href="#ranking" className="text-xs text-background-400 transition-colors hover:text-accent-400">
              完整榜单
            </a>
          </div>
          <ol className="mt-4 space-y-3.5">
            {topFive.map((item: HotTopic, index: number) => (
              <li key={item.id} className="flex gap-3.5">
                <span
                  className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-sm font-heading text-xs font-bold ${
                    index === 0
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-800 text-background-300'
                  }`}
                >
                  {index + 1}
                </span>
                <div className="min-w-0">
                  <p className="line-clamp-2 text-sm leading-snug text-background-100">{item.title}</p>
                  <p className="mt-1 flex items-center gap-2 text-[11px] text-background-500">
                    <span className="text-accent-400">{item.tag}</span>
                    <span>热度 {item.heat}</span>
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </aside>
      </div>
    </section>
  );
}